export default __webpack_public_path__ + "static/media/symphony-badge-black.b9aca636.png";